////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const TelecollectManagerComparisonStatusWrapper = styled.div`
	text-align: center;
	background-color: ${(props) => props.colorCode};
	color: ${(props) => props.theme.colors.white};
	line-height: 32px;
	font-weight: bold;
	padding: 0px 10px;
`
//////STYLED//////

const TelecollectManagerComparisonStatus = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TelecollectManagerComparisonStatusWrapper colorCode={props.row.comparisonStatus.colorCode}>
			{translations[props.row.comparisonStatus.translationKey]}
		</TelecollectManagerComparisonStatusWrapper>
	)
}

TelecollectManagerComparisonStatus.propTypes = {}

TelecollectManagerComparisonStatus.defaultPropTypes = {}

export default TelecollectManagerComparisonStatus
